import { useState, useEffect } from 'react';

const useForm = (callback, validate) => {

	const [values, setValues] = useState({});
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);

	useEffect(() => {
		if (Object.keys(errors).length === 0 && isSubmitting) {
			callback();
		}
	}, [errors]); // eslint-disable-line

	const handleSubmit = (event) => {
		if (event) event.preventDefault();
		setErrors(validate(values));
		setIsSubmitting(true);
	};

	const handleChange = (event) => {
		event.persist();
		setValues(values => ({ ...values, [event.target.name]: event.target.value }));
	};

	const updateSingleKey = (key, value) => {
		setValues(values => ({ ...values, [key]: value }));
	};

	return {
		handleChange,
		handleSubmit,
		params: values,
		errors,
		updateSingleKey
	}
};

export default useForm;